(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('ReporteDownloadService', ReporteDownloadService);

    ReporteDownloadService.$inject = ['$q','$http', '$filter'];

    function ReporteDownloadService ($q, $http, $filter) {
        var service = {
            	proyectosAprobadosPorModalidad: proyectosAprobadosPorModalidad,
            	proyectosAprobadosPorPerfilModalidad: proyectosAprobadosPorPerfilModalidad,
            	proyectosPorDependenciaModalidadTipo: proyectosPorDependenciaModalidadTipo,
            	proyectosAprobadosPorArea: proyectosAprobadosPorArea,
            	proyectosAprobadosPorFuncion: proyectosAprobadosPorFuncion,
            	proyectosAprobadosConApoyoEconomico: proyectosAprobadosConApoyoEconomico,
            	proyectosAprobadosPorDependenciaVigencia: proyectosAprobadosPorDependenciaVigencia, 
            	directorioDependencias: directorioDependencias,
            	plazasDisponibles: plazasDisponibles,
            	plazasDisponiblesAll: plazasDisponiblesAll,
            	prestadoresPorPerfil: prestadoresPorPerfil,
            	prestadoresPorDependenciaProyecto: prestadoresPorDependenciaProyecto,
            	bajasPrestadores: bajasPrestadores,
            	proyectosPorPeriodo: proyectosPorPeriodo
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function proyectosAprobadosPorModalidad (periodo, ambito, centroDocente) {
            
        	var defer = $q.defer();
                
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorModalidad/'+ periodo + "/" + ambito + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorModalidad_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorPerfilModalidad (periodo, ambito, programaEducativo) {
            
        	var defer = $q.defer();
                
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorPerfilModalidad/'+ periodo + "/" + ambito + "/" + programaEducativo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorPerfilModalidad_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosPorDependenciaModalidadTipo (periodo, estatus) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosPorDependenciaModalidadTipo/'+ periodo + "/" + estatus,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosPorDependenciaModalidadTipo_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorArea (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorArea/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorArea_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorFuncion (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorFuncion/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorFuncion_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosConApoyoEconomico (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosConApoyoEconomico/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosConApoyoEconomico_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosAprobadosPorDependenciaVigencia (periodo) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/proyectosAprobadosPorDependenciaVigencia/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosAprobadosPorDependenciaVigencia_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function directorioDependencias (periodo) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/directorioDependencias/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "directorioDependencias_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function plazasDisponiblesAll (periodo) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPlazasDisponibles/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				console.log("idPeriodo "+periodo);
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPlazasDisponibles_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function plazasDisponibles (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPlazasDisponibles/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				console.log("idPeriodo "+periodo);
				console.log("idCentroDocente "+centroDocente);
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPlazasDisponibles_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function prestadoresPorPerfil (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPorPerfil/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPorPerfil_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function prestadoresPorDependenciaProyecto (periodo, ambito) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/prestadoresPorDependenciaProyecto/'+ periodo + "/" + ambito,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "prestadoresPorDependenciaProyecto_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function bajasPrestadores (periodo, centroDocente) {
        	var defer = $q.defer();
            
            $http({
				url: 'api/s-s-reportes/bajasPrestadores/'+ periodo + "/" + centroDocente,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/pdf'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "bajasPrestadores_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
        function proyectosPorPeriodo (periodo) {
            
        	var defer = $q.defer();
                
            $http({
				url: 'api/s-s-reportes/proyectosPorPeriodo/'+ periodo,
				method : 'POST',
				params : {},
				headers : {
					'Content-type' : 'application/octet-stream',
				},
				responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
            	var date = $filter('date')(new Date(), 'dd-MM-yyyy');
				var file = new Blob([ data ], {
					type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				//trick to download store a file having its URL
				var fileURL = URL.createObjectURL(file);
				var a         = document.createElement('a');
				a.href        = fileURL; 
				a.target      = '_blank';
				a.download    = "proyectosPorPeriodo_" + date;
				document.body.appendChild(a);
				a.click();
				defer.resolve('success');
            }).error(function() {
				defer.reject('error');
			});
            return defer.promise;
        }
        
    }
})();
